import React, {Suspense, lazy} from 'react';
import {Spin} from 'antd';
import {authLoader} from '../../loader';
import {ROUTE_CALL_STOCK_REPORT} from '../../RoutePathConstant';

const CallStockReport = lazy(() =>
  import('../../../screens/CallStockReport')
    .then(module => ({default: module.CallStockReport})));

const CallStockReportNavigation = [
  {
    path:  ROUTE_CALL_STOCK_REPORT,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <CallStockReport />
      </Suspense>
    ),
  },
];

export default CallStockReportNavigation;
